import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: UserPermissions = {
  privileges: [],
  isAuthenticated: false,
  isRehydrating: true,
};

const permissionSlice = createSlice({
  name: 'userPermissions',
  initialState,
  reducers: {
    setUserPermissions(state, action: PayloadAction<Partial<UserPermissions>>) {
      Object.assign(state, action.payload);
    },
  },
});

export const { setUserPermissions } = permissionSlice.actions;

export default permissionSlice.reducer;
